import { useEffect, useState } from "react";

export const useIsDarkTheme = () => {
  const get = () => document.documentElement.getAttribute("data-theme") === "dark";
  const [isDark, setIsDark] = useState(get);

  useEffect(() => {
    const obs = new MutationObserver(() => setIsDark(get()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);

  return isDark;
}
